module.exports = __webpack_public_path__ + "img/c4be9e8.png";